import { render, staticRenderFns } from "./ReturnPartsItemList.vue?vue&type=template&id=31ae0ad0"
import script from "./ReturnPartsItemList.vue?vue&type=script&lang=js"
export * from "./ReturnPartsItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports